import api from "../utils/axios";

export const fetchSettlementDisableRequestValidation = async (
	documentTypeId: number,
	userId: any | null
) => {
	try {
		const response = await api.get("Settlement/settlement-validations", {
			params: { documentTypeId: documentTypeId, userId: userId ?? 0 },
		});
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch settlement request validation.");
		}
	} catch (error) {
		console.error(
			"An error occurred while fetchingsettlement request validation:",
			error
		);
	}
};
export const fetchSettlementValidationForInfo = async (
	documentTypeId: number,
	userId: any | null
) => {
	try {
		const response = await api.get(
			"Settlement/settlement-validation-for-description",
			{
				params: { documentTypeId: documentTypeId, userId: userId ?? 0 },
			}
		);
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch settlement request validation.");
		}
	} catch (error) {
		console.error(
			"An error occurred while fetchingsettlement request validation:",
			error
		);
	}
};
